import { useMemo } from "react";

const HEART_PATH =
  "M12 21s-7.5-4.5-9.5-9.5C1 8 3.5 5 6.5 5c2 0 3.5 1 5.5 3 2-2 3.5-3 5.5-3C20.5 5 23 8 21.5 11.5 19.5 16.5 12 21 12 21z";

function rand(min, max) {
  return Math.random() * (max - min) + min;
}

export default function FloatingHearts({ count = 14 }) {
  const hearts = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        left: rand(2, 98),
        size: rand(10, 22),
        delay: rand(0, 14),
        duration: rand(14, 26),
        opacity: rand(0.06, 0.22),
        color: i % 3 === 0 ? "#D4AF37" : i % 3 === 1 ? "#B72E4F" : "#F3E5AB",
      })),
    [count]
  );

  return (
    <div
      aria-hidden="true"
      data-testid="floating-hearts"
      className="pointer-events-none fixed inset-0 z-0 overflow-hidden"
    >
      {hearts.map((h) => (
        <svg
          key={h.id}
          viewBox="0 0 24 24"
          width={h.size}
          height={h.size}
          style={{
            position: "absolute",
            left: `${h.left}%`,
            bottom: "-40px",
            opacity: h.opacity,
            animation: `float-drift ${h.duration}s linear ${h.delay}s infinite`,
            color: h.color,
            filter: "drop-shadow(0 0 8px rgba(212,175,55,0.35))",
          }}
        >
          <path d={HEART_PATH} fill="currentColor" />
        </svg>
      ))}
    </div>
  );
}
